<template>
  <div class="shopsInfo">
    <el-card class="box-card">
      <div slot="header" style="display:flex;align-items: center">
        <i @click="onBack" class="el-icon-arrow-left" style="font-size:25px;"></i>
        <span style="font-size:25px;font-weight:bold;margin:0 10px;">{{ h_text }}</span>
      </div>
      <div style="display: flex;align-items:start;height:32vw;padding:5px 10px 5px 10px">
        <div style="width:9vw;display:flex;flex-flow: column">
          <el-image :src="d.url" v-for="(d,index) in liImg" :key="`img${index}`"
                    style="max-width:8vw;height:8vw">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div style="width:33vw">
          <el-image :src="imageUrl" style="max-width:32vw;height:32vw">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div style="width:30vw;display: flex;flex-flow:column;">
          <h5 style="margin: 0">{{ name }}</h5>
          <h5 style="color: #409EFF;margin:20px 0 10px 0">{{ fil_stateName }}</h5>
          <div style="margin:0 0 10px 0;display: flex;align-items: center">
            <h5 style="margin:0">商品分类：</h5>
            <h5 style="margin:0">{{ edi_typeName }}</h5>
          </div>
          <div style="margin:0 0 10px 0;display: flex;align-items: center">
            <h5 style="margin:0">商品简介：</h5>
            <h5 style="margin:0">{{ brief }}</h5>
          </div>
          <el-table :data=fil_tabData2 class="tab_info" :cell-style="tableYs" border
                    style="width:100%; margin-left:1px;font-size:13px; background:#FFFFFF;margin-top:1px"
                    show-overflow-tooltip
                    ref="multipleTable"
                    :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
            <el-table-column width="1">
            </el-table-column>
            <div v-for="(d, item) in this.defHead1">
              <el-table-column v-if="d.val === 'skuName' || d.val === 'skuCode'" :label=d.key :width="d.w">
                <template slot-scope="scope">
                  <p style="color:#72767b;font-size: 16px;width:80%">{{ scope.row[d.val] }}</p>
                </template>
              </el-table-column>
              <el-table-column v-else :label=d.key :width="d.w">
                <template slot-scope="scope">
                  <p style="color:#72767b;font-size: 16px;width:80%">{{ scope.row[d.val] }}</p>
                </template>
              </el-table-column>
            </div>
            <!--          <el-table-column label="操作" width="120">-->
            <!--            <template slot-scope="scope">-->
            <!--              <el-button @click="onDel(scope.$index)" type="text" size="small" icon="el-icon-delete"-->
            <!--                         style="color:#72767b;font-size: 16px"/>-->
            <!--            </template>-->
            <!--          </el-table-column>-->
          </el-table>
        </div>
      </div>
      <div style="display: flex;align-items: center">
        <p @click="onXz(true)" :class="xzMs ? 'xzMs1' : 'xzMs'" style="margin: 0;">商品描述</p>
        <p @click="onXz(false)" :class="xzMs ? 'xzMs' : 'xzMs1'" style="margin: 0 10px">累计评价</p>
      </div>
      <div v-if="xzMs"
           style="margin-top:10px"
           class="quill-viewer"
           v-html="description">
      </div>
      <div v-else style="display:flex;flex-flow: column;height:auto;margin-top:10px;">
        <el-radio-group v-model="edi_leve" @change="getFilGoodsCommentList()" style="margin-left:1px;">
          <el-radio v-for="(d,index) in liLevel" :key="`leve${index}`" :label="d.value">{{ d.label }}</el-radio>
        </el-radio-group>
        <div v-for="(d,index) in liComment" :key="`pj${index}`" style="display:flex;align-items:center">
          <div style="display: flex;flex-flow: column;justify-items: center">
            <p style="margin-top:10px;margin-bottom:1px">{{ d.userName }}</p>
            <el-rate
                v-model="d.pj"
                disabled
                show-score
                text-color="#ff9900"
                score-template="{value}">
            </el-rate>
            <p style="margin-top:1px;margin-bottom:1px">{{ d.times }}</p>
          </div>
          <p style="margin-left:10px">{{ d.txt }}</p>
        </div>
        <div style="display: flex;">
          <el-pagination
              style="margin-left:auto;margin-right:0.5vw;margin-top:5px;padding-bottom:2vh"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10,20,30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import vueCropper from "../views/vueCropper.vue";
import {quillEditor,Quill} from 'vue-quill-editor';

export default {
  name:'shopsInfo',
  components:{
    vueCropper,quillEditor
  },
  data() {
    return {
      isCtr:true,
      h_text:"商品详情",
      xzMs:true, /*选中描述*/
      goodsId:0,
      edi_leve:0,
      liLevel:[],
      page:1,
      pageSize:10,
      total:0,
      liComment:[],
      name:"",
      brief:"",
      edi_type:"",
      edi_typeName:"",
      editorOptions:{
        readOnly:true,
        theme:'snow',  /*只读模式下隐藏工具栏（关键：避免用户看到编辑按钮）*/
        modules:{
          toolbar:false /*禁用工具栏*/
        }
      },
      description:"",
      imageUrl:"",
      stateId:1,
      liSku:[],
      liImg:[],
      defHead1:[
        {'key':"规格",'val':"skuName","w":"150px",'childData':[]},
        {'key':"出售价(元)",'val':"price","w":"100px",'childData':[]},
        {'key':"原价(元)",'val':"oldPrice","w":"100px",'childData':[]},
        {'key':"库存",'val':"kuCun","w":"100px",'childData':[]},
        {'key':"规格编码",'val':"skuCode","w":"auto",'childData':[]}
      ]
    };
  },
  methods:{
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    onXz(value) {
      this.xzMs = value;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGoodsCommentList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getGoodsCommentList();
    },
    onEditorReady() {
    },
    getGoodsCommentLevelList() {
      const params = {
        page:1,
        pageSize:30,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsCommentLevelList,params,headers).then(res => {
        console.log("getGoodsCommentLevelList",res.data.data);
        let li_d = res.data.data.list;
        if (li_d && li_d.length > 0) {
          let l = [{label:"全部",value:0}];
          for (let i = 0; i < li_d.length; i++) {
            l.push({label:li_d[i]["name"],value:li_d[i]['id']});
          }
          this.liLevel = l;
        } else {
          this.liLevel = [];
        }
        this.getGoodsCommentList();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    },
    getFilGoodsCommentList() { /*获取商品评价筛选*/
      this.page = 1;
      this.getGoodsCommentList();
    },
    getGoodsCommentList() { /*获取商品评价列表*/
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        goodsId:this.goodsId,
        projectId:localStorage.getItem("projectId")
      };
      if (this.edi_leve) {
        params["commentLevelId"] = this.edi_leve;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsCommentList,params,headers).then(res => {
        console.log("getGoodsCommentList",res.data.data);
        let data = res.data.data["list"];
        if (data) {
          let l_d = [];
          for (let i = 0; i < data.length; i++) {
            //{"userName":"用户1","pj":5,"times":"2026-1-10 10:10","txt":"非常不错少时诵诗书"}
            let d_d = {
              "pj":data[i]['score'],
              "txt":data[i]['content'],
              "times":""
            };
            if (data[i]["time"]) {
              d_d["times"] = this.timestampToTime(data[i]['time'] * 1000);
            }
            if (data[i]["user"]) {
              if (data[i]['user']['phoneNumber']) {
                d_d["phoneNumber"] = data[i]['user']['phoneNumber'];
              } else {
                d_d["phoneNumber"] = data[i]['user']['applyNumber'];
              }
              if (data[i]['user']['name']) {
                d_d["userName"] = data[i]['user']['name'];
              } else if (data[i]['user']["nickName"]) {
                d_d['userName'] = data[i]['user']["nickName"];
              } else if (data[i]['user']["userName"]) {
                d_d['userName'] = data[i]["userName"];
              }
            } else {
              if (data[i]["customNumber"]) { /*手机号*/
                d_d['phoneNumber'] = data[i]["customNumber"];
              }
              if (data[i]["name"]) { /*用户名*/
                d_d['userName'] = data[i]["name"];
              } else if (data[i]["nickName"]) {
                d_d['userName'] = data[i]["nickName"];
              } else if (data[i]["userName"]) {
                d_d['userName'] = data[i]["userName"];
              }
            }
            l_d.push(d_d);
          }
          this.liComment = l_d;
        } else {
          this.liComment = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes());
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m;
    },
    getGoodsInfo(goodsId) {
      const params = {
        id:goodsId,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoods,params,headers).then(res => {
        console.log("getGoodsInfo",res.data.data);
        let d = res.data.data.data;
        this.name = d.name;
        this.brief = d.brief;
        this.edi_type = d.goodsType.id;
        this.edi_typeName = d.goodsType.name;
        this.description = d.description;
        let imgs = d.goodsBanners;
        this.liImg = [];
        if (d["iconBig"]) {
          this.imageId = d["iconBig"]['id'];
          this.imageUrl = this.$urls.ip + "/" + d["iconBig"]["url"];
        }
        for (let i = 0; i < imgs.length; i++) {
          if (imgs[i]["url"]) {
            this.liImg.push({"id":imgs[i].id,url:this.$urls.ip + "/" + imgs[i]["url"].url});
          }
        }
        this.stateId = d.goodsState['id'];
        let skuS = d.goodsSku;
        for (let i = 0; i < skuS.length; i++) {
          if (skuS[i]['skuPrice'] && skuS[i]['skuPrice'].length > 0) {
            this.liSku.push(
                {
                  id:skuS[i]['id'],skuName:skuS[i]['skuName'],skuCode:skuS[i]['skuCode'],kuCun:skuS[i]['kuCun'],
                  price:skuS[i]['skuPrice'][0]['price'] / 100,oldPrice:skuS[i]['skuPrice'][0]['originPrice'] / 100,
                  priceId:skuS[i]['skuPrice'][0]['id']
                }
            );
          }
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    }
  },
  mounted() {
    this.h_text = "商品详情";
    this.goodsId = this.$route.query.key;
    this.getGoodsCommentLevelList(); /*获取评价等级*/
    this.getGoodsInfo(this.goodsId);
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData2() {
      return this.liSku.filter(item => {
        this.state = true;
        return this.state;
      });
    },
    fil_stateName() {
      let stateName = "商品上架中";
      if (this.stateId === 1) {
        stateName = "商品上架中";
      } else {
        stateName = "商品已下架";
      }
      return stateName;
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style scoped>
.shopsInfo {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.xzMs1 {
  color: blue;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid blue;
}

.xzMs {
  color: #8f8f94;
  font-size: 18px;
}

.tab_info {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

.quill-viewer :deep(.ql-container) {
  border: none !important;
  box-shadow: none !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
}

.quill-viewer :deep(.ql-editor) {
  cursor: default !important;
  background-color: transparent !important;
  contenteditable: false !important;
  user-select: text !important; /* 如果连选中复制都不想要，改成 none */
  padding: 0 !important;
}

.quill-viewer :deep(.ql-toolbar),
.quill-viewer :deep(.ql-stroke),
.quill-viewer :deep(.ql-formats) {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/shopsInfo.vue